import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchQuestionsByCourseId } from '../../services/firestore/questionService';
import { generateQuiz } from '@e-learning/shared/src/quiz/quizGenerator';
import { getQuestionDifficultyFilter } from '../../services/quizAttemptService';

/**
 * Fetch questions and generate a quiz for a course
 * @param courseId Course ID
 * @param isAuthenticated Whether the user is authenticated (affects question difficulty)
 */
export const generateQuizForCourse = createAsyncThunk(
  'quiz/generate',
  async (
    { courseId, isAuthenticated }: { courseId: string; isAuthenticated: boolean },
    { rejectWithValue }
  ) => {
    try {
      const questions = await fetchQuestionsByCourseId(courseId);
      if (questions.length === 0) {
        return rejectWithValue('No questions available for this course');
      }
      
      // Get allowed difficulties based on authentication status
      const allowedDifficulties = getQuestionDifficultyFilter(isAuthenticated);
      
      const quiz = generateQuiz(questions, courseId, 10, allowedDifficulties);
      return quiz;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to generate quiz');
    }
  }
);

